import SEQUENCE_REDUX_CONSTANT from '../../constants/sequenceReduxConstant/SequenceReduxConstant';

const initialValue = {
    sequences: [],
    currentSequence: null,
    isLoadingSequences: false,
    isLoadingSequence: false,
    isCreatingSequence: false,
    isUpdatingSequence: false,
    isEnrolling: false,
    enrollmentStatus: null,
    sequenceEnrollments: null,
    isLoadingEnrollments: false,
    sequenceError: null,
};

const sequenceReducer = (state = initialValue, action) => {
    switch (action.type) {
        case SEQUENCE_REDUX_CONSTANT.SET_SEQUENCES:
            return {
                ...state,
                sequences: action.data,
            };

        case SEQUENCE_REDUX_CONSTANT.SET_LOADING_SEQUENCES:
            return {
                ...state,
                isLoadingSequences: action.data,
            };

        case SEQUENCE_REDUX_CONSTANT.SET_CURRENT_SEQUENCE:
            return {
                ...state,
                currentSequence: action.data,
                sequenceError: null,
            };

        case SEQUENCE_REDUX_CONSTANT.SET_LOADING_SEQUENCE:
            return {
                ...state,
                isLoadingSequence: action.data,
            };

        case SEQUENCE_REDUX_CONSTANT.SET_CREATING_SEQUENCE:
            return {
                ...state,
                isCreatingSequence: action.data,
            };

        case SEQUENCE_REDUX_CONSTANT.SET_UPDATING_SEQUENCE:
            return {
                ...state,
                isUpdatingSequence: action.data,
            };

        case SEQUENCE_REDUX_CONSTANT.SET_ENROLLING:
            return {
                ...state,
                isEnrolling: action.data,
            };

        case SEQUENCE_REDUX_CONSTANT.SET_ENROLLMENT_STATUS:
            return {
                ...state,
                enrollmentStatus: action.data,
            };

        case SEQUENCE_REDUX_CONSTANT.SET_SEQUENCE_ENROLLMENTS:
            return {
                ...state,
                sequenceEnrollments: action.data,
            };

        case SEQUENCE_REDUX_CONSTANT.SET_LOADING_ENROLLMENTS:
            return {
                ...state,
                isLoadingEnrollments: action.data,
            };

        case SEQUENCE_REDUX_CONSTANT.SET_SEQUENCE_ERROR:
            return {
                ...state,
                sequenceError: action.data,
            };

        case SEQUENCE_REDUX_CONSTANT.CLEAR_SEQUENCE_ERROR:
            return {
                ...state,
                sequenceError: null,
            };

        default:
            return state;
    }
};

export default sequenceReducer;
